import { msg } from '@lingui/core/macro';
import { IPresets } from 'modules/template-editor/domain/consts/form/presets';

export enum BoardPresets {
  create = 'create',
  edit = 'edit',
  duplicate = 'duplicate',
  copy = 'copy',
  delete = 'delete',
}

export const boardPresets: Record<BoardPresets, IPresets> = {
  create: {
    header: msg`Новое табло`,
    submitButton: msg`Создать`,
  },
  edit: {
    header: msg`Редактирование табло`,
    submitButton: msg`Сохранить`,
  },
  duplicate: {
    header: msg`Дублирование табло`,
    submitButton: msg`Дублировать`,
  },
  copy: {
    header: msg`Копирование табло`,
    submitButton: msg`Скопировать`,
  },
  delete: {
    header: msg`Удаление табло`,
    submitButton: msg`Удалить`,
  },
};
